export default __webpack_public_path__ + "static/media/belt.ab6fdcbf.png";